import { CreditCardDirectivesModule, CreditCardValidators } from 'angular-cc-library';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PaymentConfirmationComponent } from 'src/app/component/payment-confirmation/payment-confirmation.component';
import { TicketConfirmationComponent } from 'src/app/component/ticket-confirmation/ticket-confirmation.component';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { EventService } from 'src/app/services/event.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BusticketService } from '@core/services';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { PayCodeCard } from '@shared/models';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, CreditCardDirectivesModule],
  selector: 'app-payment-card-paycode',
  templateUrl: './payment-card-paycode.page.html',
  styleUrls: ['./payment-card-paycode.page.scss'],
})
export class PaymentCardPayCodePage implements OnInit {
  #busticketService: BusticketService = inject(BusticketService);
  form: UntypedFormGroup;
  submitted = false;
  ccType: string;
  address;
  amount = 200;
  subscriptionSelection;
  subscriptionRadial;
  busticketItem;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private eventService: EventService,
    private modalCtrl: ModalController,
    private dataService: DataService,
    private navCtrl: NavController,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    if (this.dataService.getData('payment-amount')) {
      this.amount = this.dataService.getData('payment-amount');
    } else if (this.dataService.getData('subscription-selection')) {
      this.subscriptionSelection = this.dataService.getData('subscription-selection');
      // console.log('subscriptionSelection: ', this.subscriptionSelection);
      this.amount = this.subscriptionSelection.price;
      // console.log('amount: ', this.amount);
    } else if (this.dataService.getData('subscription-radial')) {
      this.subscriptionRadial = this.dataService.getData('subscription-radial');
      // console.log('subscriptionRadial: ', this.subscriptionRadial);
      this.amount = this.subscriptionRadial.price;
      // console.log('amount: ', this.amount);
    } else if (this.dataService.getData('busticket-item')) {
      this.busticketItem = this.dataService.getData('busticket-item');
      console.log('busticketItem: ', this.busticketItem);
      this.amount = this.busticketItem.price;
      console.log('amount: ', this.amount);
    }
    this.form = this.formBuilder.group({
      fullname: ['', [Validators.required]],
      creditCard: ['', [CreditCardValidators.validateCCNumber]],
      expirationDate: ['', [CreditCardValidators.validateExpDate]],
      cvc: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
    });
    this.unsetData();
  }

  unsetData() {
    this.dataService.setData('payment-amount', null);
    this.dataService.setData('subscription-selection', null);
    this.dataService.setData('subscription-radial', null);
    this.dataService.setData('busticket-item', null);
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      this.createToken();
    }
  }

  ccTypeCheck(event) {
    if (event.srcElement.classList.contains('visa')) {
      this.ccType = 'visa';
    } else if (event.srcElement.classList.contains('mastercard')) {
      this.ccType = 'mastercard';
    } else if (event.srcElement.classList.contains('amex')) {
      this.ccType = 'amex';
    } else {
      this.ccType = '';
    }
  }

  createToken() {
    this.eventService.publish('loading:present');
    const exp = this.form.controls['expirationDate'].value.split('/');
    const card = {
      number: this.form.controls['creditCard'].value.replaceAll(' ', ''),
      holder_name: this.form.controls['fullname'].value,
      exp_year: exp[1].trim(),
      exp_month: exp[0].trim(),
      cvc: this.form.controls['cvc'].value,
    };
    this.processPayment(card);
  }

  processPayment(card: PayCodeCard) {
    if (this.subscriptionRadial) {
      this.apiService
        .postData('suscription-radial-payments', {
          method: 'credit_card',
          suscription: this.subscriptionRadial,
          sto_id: this.subscriptionRadial.id,
          amount: this.amount,
          card,
        })
        .then((res) => {
          if (res.success && res.data) {
            this.showResponse(res.data);
          } else {
            if (res.error) {
              const error = res.error;
              this.notificationService.presentToast('Error: ' + 'Cargo rechazado por el procesador de pagos.');
            }
            this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
          }
        })
        .finally(() => {
          this.eventService.publish('loading:dismiss');
        });
    } else if (this.subscriptionSelection) {
      this.apiService
        .postData('suscription-payments', {
          method: 'credit_card',
          sto_id: this.subscriptionSelection.id,
          amount: this.amount,
          card,
        })
        .then((res) => {
          if (res.success && res.data) {
            this.showResponse(res.data);
          } else {
            if (res.error) {
              this.notificationService.presentToast('Error: ' + 'Cargo rechazado por el procesador de pagos.');
            }
            this.navCtrl.navigateRoot(['/tecservice-transportec/wallet']);
          }
        })
        .finally(() => {
          this.eventService.publish('loading:dismiss');
        });
    } else if (this.busticketItem) {
      this.#busticketService
        .create({
          method: 'credit_card',
          amount: this.amount,
          bus_id: this.busticketItem.ticket.trip.bus_id,
          realtrip_id: this.busticketItem.ticket.trip.id,
          stop_id: this.busticketItem.ticket.search.stop.id,
          starts_at: this.busticketItem.ticket.trip.starts_at,
          date: this.busticketItem.ticket.search.date,
          card,
        })
        .pipe(
          catchError((error) => {
            this.notificationService.presentToast('Error: ' + error);
            return of(null);
          })
        )
        .subscribe((res: any) => {
          if (res?.success) {
            this.goTicket(res.busticket);
          } else {
            this.notificationService.presentToast('Ocurrió un error favor de intentarlo más tarde.');
          }
          this.eventService.publish('loading:dismiss');
        });
    } else {
      this.apiService
        .postData('pay_balance', {
          method: 'credit_card',
          amount: this.amount,
          card,
        })
        .then((res) => {
          if (res.success && res.data) {
            this.showResponse(res);
          } else {
            if (res.error) {
              this.notificationService.presentToast('Error: ' + 'Cargo rechazado por el procesador de pagos.');
            }
            this.navCtrl.navigateRoot(['/tecservice-transportec/wallet']);
          }
        })
        .finally(() => {
          this.eventService.publish('loading:dismiss');
        });
    }
  }

  showResponse(response) {
    this.loadingService.present();
    setTimeout(() => {
      this.modalCtrl
        .create({
          component: PaymentConfirmationComponent,
          componentProps: {
            amount: this.amount,
            method: 'credit_card_paycode',
            order: response.order,
            payment: response.data,
          },
        })
        .then((modal) => {
          modal.present();
          modal.onDidDismiss().then(() => {
            this.navCtrl.navigateRoot(['/tecservice-transportec/wallet']);
          });
          this.loadingService.dismiss();
        });
    }, 1000);
  }

  goTicket(ticket) {
    if (ticket) {
      this.modalCtrl
        .create({
          component: TicketConfirmationComponent,
          componentProps: { amount: this.amount },
        })
        .then((modal) => {
          modal.present();
          modal.onDidDismiss().then((res) => {
            this.dataService.setData(ticket.id, ticket);
            this.navCtrl.navigateRoot(['/tecservice-transportec/tickets/ticket/', ticket.id]);
          });
        });
    }
  }
}
